import { Component, OnDestroy, OnInit } from '@angular/core';
import { ExtraFieldType } from '../extra-field-type';
import { GaFormlyUtil } from '../ga-formly.util';
import { FormlyValueChangeEvent } from '@ngx-formly/core/lib/components/formly.field.config';
import { Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { FormlyType } from '../ga-formly.service';
import { TranslationService } from '../../translation/translation.service';

@Component({
  selector: 'formly-field-checkbox',
  template: `
    <div class="form-check checkbox" [class.with-wrapper]="!to.noWrapper">
      <label class="form-check-label-wrapper" [class]="{'disabled': disableExpression()}">
        <input class="form-check-input" [class.form-check-inline]="to.inline" type="checkbox" [ngClass]="classNames" [formControl]="formControl" [formlyAttributes]="field" [attr.disabled]="disableExpression() ? 'true' : null">
        <ng-container *ngIf="!to.componentName">
          <span class="form-check-label label-text" [class.req]="to.required" [innerHTML]="formatLabel(to.label)" *ngIf="to.noWrapper"></span>
        </ng-container>
        <ng-container *ngIf="to.componentName">
          <ndc-dynamic [ndcDynamicComponent]="to.componentName" [ndcDynamicInputs]="to.inputs" [ndcDynamicOutputs]="to.outputs"></ndc-dynamic>
        </ng-container>
      </label>
    </div>
  `
})
export class FormlyFieldCheckboxComponent extends ExtraFieldType implements OnInit, OnDestroy {
  private fieldChangesSubscription:Subscription;
  public disableExpression:Function;

  constructor(
    private formlyUtil:GaFormlyUtil,
    private translationService:TranslationService
  ) {
    super();
  }

  public ngOnInit():void {
    this.classNames = this.formlyUtil.createClassNames(FormlyType.CHECKBOX, <string>this.key, this.to.label);
    this.disableExpression = () => this.to.disableExpression && this.to.disableExpression(this.to.label);

    // register listener
    this.listen();
  }

  protected listen():void {
    super.listen();

    this.fieldChangesSubscription = this.options.fieldChanges.subscribe((changes:FormlyValueChangeEvent) => {
      if (changes.property === 'templateOptions.required' && changes.field?.key === this.key) {
        // setting templateOptions.required won't simply trigger built-in required validation
        // because checkbox requires 'requiredTrue' instead regular 'required'
        if (changes.value) {
          this.formControl.validator = Validators.requiredTrue;
          this.formControl.updateValueAndValidity();
        } else {
          this.formControl.clearValidators();
          this.formControl.updateValueAndValidity();
        }
      }
    });
  }

  public formatLabel(label:string):string {
    const formatFn:Function = this.formlyUtil.getFormatFn(this.to.format);
    return this.translationService.instant(formatFn(label));
  }

  public ngOnDestroy():void {
    this.fieldChangesSubscription?.unsubscribe();
  }
}